module.exports = __webpack_public_path__ + "img/section4.00099785.jpg";